<ngx-loading-bar></ngx-loading-bar>
<fs-header *ngIf="isNotIframe() && !isLoginPage()"> </fs-header>
<main [ngClass]="isNotIframe() ? '' : 'fs-iframe'">
  <router-outlet> </router-outlet>
</main>
<fs-notifications-bell *ngIf="isNotIframe() && !isLoginPage()"></fs-notifications-bell>
